
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkVoucherTypeEnum } from '../models/work-voucher-type-enum';
import { WorkVoucherAmountBasisEnum } from '../models/work-voucher-amount-basis-enum';
import { WorkVoucherBookingModeEnum } from '../models/work-voucher-booking-mode-enum';
import { WorkVoucherAftercalcDto } from '../models/work-voucher-aftercalc-dto';
import { WorkVoucherLineDto } from '../models/work-voucher-line-dto';

export function getUpdateVoucherDtoFormGroup() {
return new FormGroup({
    voucherType: new FormControl<WorkVoucherTypeEnum | undefined>(undefined),
    documentId: new FormControl<number | undefined>(undefined),
    accountingPartnerId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    merchantName: new FormControl<string | undefined>(undefined, [Validators.maxLength(255)]),
    externalReference: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    voucherDate: new FormControl<string | undefined>(undefined),
    dispositionDate: new FormControl<string | undefined>(undefined),
    dueDate: new FormControl<string | undefined>(undefined),
    currency: new FormControl<string | undefined>('', [Validators.maxLength(3), Validators.minLength(3)]),
    fxRate: new FormControl<number | undefined>(undefined, [Validators.min(0)]),
    fxRateDate: new FormControl<string | undefined>(undefined),
    fxRateSource: new FormControl<string | undefined>(undefined, [Validators.maxLength(20)]),
    amountGross: new FormControl<number | undefined>(undefined),
    amountNet: new FormControl<number | undefined>(undefined),
    amountBasis: new FormControl<WorkVoucherAmountBasisEnum | undefined>(undefined),
    taxCodeId: new FormControl<number | undefined>(undefined),
    iban: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    paymentReference: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    discountPercent: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(100)]),
    discountDays: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(365)]),
    discountUntil: new FormControl<string | undefined>(undefined),
    paymentConditionId: new FormControl<number | undefined>(undefined),
    paymentMethodId: new FormControl<number | undefined>(undefined),
    expensePaymentMethodId: new FormControl<number | undefined>(undefined),
    bookingMode: new FormControl<WorkVoucherBookingModeEnum | undefined>(undefined),
    projectId: new FormControl<number | undefined>(undefined),
    orderId: new FormControl<number | undefined>(undefined),
    approvalRequired: new FormControl<boolean | undefined>(undefined),
    approvalOverride: new FormControl<boolean | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined, [Validators.maxLength(5000)]),
    recognition: new FormControl<any | undefined>(undefined),
    aftercalc: new FormControl<WorkVoucherAftercalcDto | undefined>(undefined),
    lines: new FormControl<WorkVoucherLineDto[]>([]),
    complete: new FormControl<boolean | undefined>(undefined),
})
;
}
      